<!--
 * @Author: yuanjianlong
 * @Description: 添加组员弹框
 * @Date: 2022-02-28 15:39:50
 * @LastEditTime: 2024-09-13 14:09:54
 * @FilePath: /teacher-h5/src/components/AddGroupMemberModal.vue
-->
<template>
  <a-modal
    :visible="visible"
    title="选择学员"
    wrap-class-name="batch-modal"
    :closable="false"
    :width="1100"
    :mask-closable="false"
    centered
    ok-text="确认选择"
    :confirm-loading="confirmLoading"
    :z-index="100"
  >
    <a-spin :spinning="loading">
      <div class="filter">
        <a-form-model layout="inline" :model="form">
          <a-form-model-item>
            <a-input
              v-model="form.studentName"
              style="width: 160px"
              placeholder="请输入学员姓名"
              allow-clear
            />
          </a-form-model-item>
          <a-form-model-item>
            <a-input
              v-model="form.phoneNumber"
              style="width: 160px"
              placeholder="请输入学员手机号"
              allow-clear
            />
          </a-form-model-item>
          <!-- <a-form-model-item>
            <a-input
              v-model="form.schoolName"
              style="width: 160px"
              placeholder="请输入学校"
              allow-clear
            />
          </a-form-model-item> -->
          <a-form-model-item>
            <a-select
              v-model="form.gradeId"
              placeholder="请选择年级"
              style="width: 160px"
              allow-clear
            >
              <a-select-option v-for="(item, index) in gradeList" :key="index" :value="item.key">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-select
              v-model="form.jurisdiction"
              placeholder="请选择权益类型"
              style="width: 160px"
              allow-clear
            >
              <a-select-option v-for="item in jurisdictionTypeListCom" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-button class="search-btn" type="primary" @click="onSearch">
              搜索
            </a-button>
            <a-button @click="onReset">
              重置
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
      <div class="batch-wap" :style="{'height': batchHeight+'px'}">
        <div class="batch-wap-left">
          <!-- getCheckboxProps: getCheckboxProps -->
          <a-table
            class="tableWap"
            :columns="columns"
            :data-source="dataSource"
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onSelect: onSelect,
              onSelectAll: onSelectAll,
              onChange: onChange,
              getCheckboxProps: record => ({
                props: {
                  disabled: this.userInfo.gddHide && [0].includes(record.jurisdiction)
                },
              }),
            }"
            :custom-row="customRowFun"
            row-key="userId"
            :scroll="{ y: scrollY}"
            :pagination="false"
          >
            <div class="tip-group-box" slot="studentName" slot-scope="text, row">
              <span class="text-ellipsis"> {{ text }} </span>
              <p class="tip-group" v-if="row.otherGroup && selectedRows.map(k => k.id).includes(row.id)">
                * 学生已存在在同课程的其他小组中，请谨慎操作
              </p>
            </div>
            <span class="study-cards" slot="createTime" slot-scope="text">
              {{ text ? dateFormat(new Date(text), 'yyyy-MM-dd hh:mm:ss') : '--' }}
            </span>
            <div class="tip-group-box" slot="jurisdiction" slot-scope="text">
              <span> {{ getJurisName(text) }} </span>
            </div>
            <span slot="courseNameStringList" slot-scope="text, row" style="display: flex;">
              <a-tooltip v-if="text && text.length > 0" :title="text[0]" placement="topRight">
                <span class="course-name">{{ text[0] }}</span>
              </a-tooltip>
              <span v-else>{{ '--' }}</span>
              <a-tooltip placement="bottomRight" trigger="click" @click="(e) => { e.stopPropagation();}">
                <template slot="title" v-if="text">
                  <ul v-for="(courseName, idx) in text" :key="idx">
                    <li v-show="idx < 5">{{ courseName }}</li>
                  </ul>
                  <p v-show="text.length > 5">...</p>
                </template>
                <!-- 计数 -->
                <div style="width: 30px;">
                  <a-badge
                    v-if="row.courseCount > 1"
                    :count="row.courseCount"
                    :number-style="{
                      backgroundColor: '#fff',
                      color: '#999',
                      boxShadow: '0 0 0 1px #d9d9d9 inset',
                      cursor: 'pointer'
                    }"
                  />
                </div>
              </a-tooltip>
            </span>
          </a-table>
          <div class="pagination">
            <a-pagination
              v-if="dataSource && dataSource.length > 0"
              v-model="pagination.current"
              :page-size="pagination.pageSize"
              :page-size-options="['10', '20', '30', '40']"
              :default-current="1"
              :total="pagination.total"
              @change="onPageChange"
              @showSizeChange="onShowSizeChange"
            />
          </div>
        </div>
        <div class="batch-wap-right">
          <div class="head">
            <div class="hasSelect">
              已选学员({{ selectedLength }}/100人)
            </div>
            <div class="clearAll" @click="clearAll">
              清空
            </div>
          </div>
          <ul v-if="selectedRows.length>0">
            <li v-for="(item, index) in selectedRows" :key="item.userId">
              <div class="li-content">
                <p class="selected-student">
                  <span class="selected-name">{{ item.studentName }}</span>
                  <CardTag :jurisdiction="item.jurisdiction" />
                </p>
                <p class="phone">
                  {{ item.phoneNumber }}
                </p>
              </div>
              <i class="icon-close iconfont delete" @click="del(index, item.userId)" />
            </li>
          </ul>
          <ComNull v-else :show-img="false" type="2" desc="请选择学员" />
        </div>
      </div>
    </a-spin>
    <template slot="footer">
      <div class="footer-wrap">
        <div>
          <div v-gdd-hide>
            <p v-if="rightTip" class="tip-wrap">
              <a-icon class="tip-icon" type="exclamation-circle" />&nbsp;{{ rightTip }}
            </p>
          </div>
        </div>
        <div>
          <a-button key="cancel" @click="onCancel">
            取消
          </a-button>
          <a-button type="primary" @click="onOK">
            确认选择
          </a-button>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
import ComNull from './ComNull.vue'
import CardTag from './CardTag.vue'
import { dateFormat } from '@aixuexi/tol-utils'
import mixins from '@/utils/mixins'
import { mapGetters } from 'vuex'
// import baseDataCache from '@/utils/getBaseData.js'
const columns = [
  {
    title: '学员姓名',
    dataIndex: 'studentName',
    key: 'studentName',
    ellipsis: true,
    width: 80,
    scopedSlots: { customRender: 'studentName' }
  },
  {
    title: '手机号',
    dataIndex: 'phoneNumber',
    width: 120,
    key: 'phoneNumber'
  },
  {
    title: '年级',
    dataIndex: 'gradeName',
    width: 70,
    key: 'gradeName'
  },
  {
    title: '权益类型',
    dataIndex: 'jurisdiction',
    width: 100,
    key: 'jurisdiction',
    scopedSlots: { customRender: 'jurisdiction' }
  },
  {
    title: '学习机课程',
    dataIndex: 'courseNameStringList',
    key: 'courseNameStringList',
    scopedSlots: { customRender: 'courseNameStringList' }
  },
  {
    title: '添加来源',
    dataIndex: 'origin',
    width: 132,
    key: 'origin',
    customRender: text => (text === 'xkhTeacher' ? '小括狐教师端' : text === 'gddUser' ? '高豆豆' : '--')
  },
  {
    title: '添加时间',
    width: 110,
    dataIndex: 'createTime',
    key: 'createTime',
    scopedSlots: { customRender: 'createTime' }
  }
]

const dataSourceTips = [{ title: '1' }, { title: '1' }, { title: '3' }]

export default {
  components: {
    ComNull,
    CardTag
  },
  mixins: [mixins],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectedKeys: {
      type: Array,
      default: () => []
    },
    selectedList: {
      type: Array,
      default: () => []
    },
    // 小组Id
    groupId: {
      type: Number,
      default: -1
    },
    classTypeId: {
      type: Number,
      default: -1
    },
    // 课程信息
    courseInfo: Object,
    lessonIdList: Array,
    useCiCard: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataSourceTips,
      // form: { groupName: '', phoneNumber: '', schoolName: '', gradeId: undefined },
      form: { groupName: '', phoneNumber: '', gradeId: undefined, jurisdiction: -1 },
      gradeList: [],
      activeSubjectId: 0,
      searchKey: undefined,
      subjectList: [],
      columns,
      dataSource: [],
      selectedRows: [],
      selectedRowKeys: [],
      loading: false,
      batchHeight: 0,
      scrollY: 0,
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        'show-size-changer': true,
        'page-size-options': ['10', '20', '30', '40'],
        showSizeChange: this.showSizeChange
      },
      disabledKeys: [],
      confirmLoading: false,
      showTip: false,
      // 权益类型，{ id: 0, name: "无权益"}
      jurisTypeList: []
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo/userInfo'
    }),
    // 已选讲次总数
    selectedLength () {
      return this.selectedRows.length
    },
    // 权益提醒
    rightTip() {
      const { courseInfo } = this
      if (!courseInfo) {
        return ''
      }
      // classStyle	1长线课\2短线课\3公开课
      const { experience, classStyle, cardType } = courseInfo
      if (classStyle === 1 && experience === 0 && (cardType == 11 || cardType === 12)) {
        // 长线非体验课，并且是一类、二类
        return '注意：“无权益”和“体验权益”的学生将会占用机构权益包名额'
      } else if (experience === 1) {
        // 当课程为打了体验课标签时
        return '注意：体验课需要学生具有体验或全科权益后才能开始学习。'
      }
      return ''
    },
    jurisdictionTypeListCom() {
      return this.jurisdictionTypeList?.filter(j => (this.userInfo.gddHide && ![0, 1].includes(j.id)) || !this.userInfo.gddHide)
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          // this.showTip = false
          this.onReset()
          this.initData()
        }
      }
    },
    selectedRows() {
      this.selectedRowKeys = this.selectedRows.map(i => i.userId)
      console.log('watch', this.selectedRowKeys)
    }
  },
  methods: {
    async init() {
      // const { jurisdictionType } = await baseDataCache.getResult()
      // this.jurisTypeList = jurisdictionType
    },
    getJurisName(text) {
      const { jurisdictionTypeList } = this
      const res = jurisdictionTypeList.find(item => item.id === text)
      return res ? res.name : '--'
    },
    dateFormat,
    /**
     * @description 重置筛选项
     */
    onReset() {
      Object.keys(this.form).forEach(item => { this.form[item] = undefined })
    },
    /**
     * 获取年级列表
     */
    getGradeList() {
      this.$service.courseAndGroup.getGradeList().then(res => {
        const { gradeList } = res
        this.gradeList = gradeList.map(item => ({
          key: item.id,
          name: item.name
        }))
      })
    },
    /**
     * table行的点击事件
     */
    customRowFun(record) {
      return {
        on: {
          click: () => {
            if ((this.userInfo.gddHide && ![0, 3].includes(record.jurisdiction)) || !this.userInfo.gddHide) {
              this.changeStudentChecked(record)
            }
          }
        }
      }
    },
    /**
     * 改变学生选中状态
     */
    changeStudentChecked(student) {
      const index = this.selectedRows.findIndex(item => item.userId === student.userId)
      if (~index) {
        this.selectedRows.splice(index, 1)
        // this.showTip = false
      } else {
        if (this.selectedRows && this.selectedRows.length > 99) {
          this.$message.error('最多添加100个学员！')
          return
        }
        this.selectedRows.push(student)
        // this.showTip = student.otherGroup
      }
    },
    /**
     * 是否不可点击
     */
    // checkStudentDisabled(record) {
    //   return record.otherGroup
    // },
    /**
     * 点击搜索
     */
    onSearch() {
      this.pagination.current = 1
      this.getStudentList()
    },
    /**
     * 是否可点击
     */
    // getCheckboxProps(record) {
    //   return {
    //     props: {
    //       disabled: record.otherGroup
    //     }
    //   }
    // },
    /**
     * 切换页码
     */
    onPageChange(current) {
      this.pagination.current = current
      this.getStudentList()
    },
    /*
     * 改变每页展示的数量
     */
    onShowSizeChange(current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getStudentList()
    },
    /**
     * 确认选择
     */
    onOK() {
      this.$emit('onOk', this.selectedRows, this.selectedRowKeys)
      this.$emit('update:visible', false)
    },
    /**
     * 关闭弹框
     */
    onCancel() {
      this.$emit('update:visible', false)
    },
    /**
     * 初始化数据
     */
    async initData() {
      this.selectedRowKeys = JSON.parse(JSON.stringify(this.selectedKeys))
      this.selectedRows = JSON.parse(JSON.stringify(this.selectedList))
      // 获取年级
      this.getGradeList()
      await this.getStudentList()
      this.onResize()
    },
    /**
     * @description: 获取列表内容
     * @param  {*}
     * @return {*}
     */
    async getStudentList () {
      try {
        this.loading = true
        const result = await this.$service.courseAndGroup.getStudentList({
          ...this.form,
          classTypeId: this.classTypeId,
          groupId: this.groupId,
          lessonIdList: this.lessonIdList,
          useCiCard: this.useCiCard,
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize
        })
        this.dataSource = result.list
        this.pagination.total = result.itemTotal
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    onSelect(record, selected, selectedRows) {
      if (selected) {
        if (this.selectedRows && this.selectedRows.length > 99) {
          this.$message.error('最多添加100个学员！')
          return
        }
        selectedRows && selectedRows.forEach(element => {
          if (this.selectedRows.findIndex(i => i.userId === element.userId) < 0) {
            this.selectedRows.push(element)
          }
        })
        // this.showTip = record.otherGroup
      } else {
        const idx = this.selectedRows.findIndex(i => i.userId === record.userId)
        this.selectedRows.splice(idx, 1)
        // this.showTip = false
      }
    },
    onSelectAll(selected, selectedRows, changeRows) {
      const selectLength = selectedRows ? selectedRows.length : 0
      const preLength = this.selectedRows.length
      if (selected) {
        if (selectLength + preLength > 100) {
          this.$message.error('最多添加100个学员！')
          return
        }
        selectedRows && selectedRows.forEach(element => {
          if (this.selectedRows.findIndex(i => i.userId === element.userId) < 0) {
            this.selectedRows.push(element)
          }
        })
      } else {
        changeRows.forEach(element => {
          const idx = this.selectedRows.findIndex(i => i.userId === element.userId)
          if (idx > -1) {
            this.selectedRows.splice(idx, 1)
          }
        })
      }
    },
    onChange(selectedRowKeys, selectedRows) {
      // selectedRowKeys 设置要配合change事件
      selectedRows && selectedRows.forEach(element => {
        if (this.selectedRows.findIndex(i => i.studentUserId === element.studentUserId) < 0) {
          this.selectedRows.push(element)
        }
      })
    },
    /**
     * @description: 删除讲次
     * @param {*} idx
     * @return {*}
     */
    del(idx, lessionId) {
      this.selectedRows.splice(idx, 1)
      this.selectedRowKeys = this.selectedRowKeys.filter(item => !(item === lessionId))
    },
    clearAll() {
      const thiz = this
      if (this.selectedRowKeys.length < 1) return
      this.$confirm({
        title: '是否移除已选全部学员？',
        zIndex: 3000,
        onOk() {
          thiz.selectedRows = []
          thiz.selectedRowKeys = []
          // this.showTip = false
        }
      })
    },
    onResize() {
      if (document.body) {
        this.batchHeight = document.body.clientHeight - 210
        this.scrollY = document.querySelector('.tableWap')?.clientHeight - 42
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style lang="less" scoped>
@import '~@/static/css/base.less';
.tip-group-box {
  .tip-group {
    position: absolute;
    font-size: 12px;
    left: 13px;
    color:#f00;
  }
}
.batch-modal {
  :deep(.ant-modal-body) {
    padding: 0;
  }
}
:deep(.ant-modal) {
  padding: 0;
}
:deep(.ant-modal-body) {
  padding: 0;
}
.filter {
  padding: 20px;
  .search-btn {
    margin-right: 20px;
  }
}
.batch-wap{
  display: flex;
  border-top: 1px solid @gray-7;
  &::after{
    clear: both;
    display: block;
    content: '';
    height: 0;
  }
  .batch-wap-left{
    width: calc(100% - 260px);
    overflow-x: auto;
    overflow-y: hidden;
    height: 100%;
    padding: 24px;
    display: flex;
    flex-direction: column;
    position: relative;
    .course-name {
      display: inline-block;
      width: 70%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .filter{
      flex-shrink: 0;
      margin-bottom: 24px;
      &::after{
        clear: both;
        display: block;
        content: '';
        height: 0;
      }
      .filter-left{
        float: left;
        .select {
          width: 139px;
          min-width: 120px;
          margin-left: 8px;
        }
        .select-name{
          margin-left: 8px;
        }
      }
      .filter-search{
        float: right;
      }
    }
    .tableWap{
      flex-grow: 1;
      overflow: auto;
      :deep(.ant-table) {
        // height: calc(100% - 56px - 72px);
      }
      .study-cards {
        display: flex;
        flex-wrap: wrap;

        .card-item {
          font-size: 14px;
          line-height: 22px;
          margin-bottom: 6px;
          margin-right: 16px;
        }
      }
    }
    .pagination {
      display: flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: flex-end;
      margin-top: 24px;
      background-color: white;
    }
  }
  .batch-wap-right{
    display: flex;
    flex-direction: column;
    width: 280px;
    border-left: 1px solid @gray-7;
    padding: 24px 6px 24px 24px;
    .head{
      padding-right: 10px;
      display: flex;
      font-size: 14px;
      line-height: 40px;
      margin-bottom: 24px;
      .hasSelect{
        flex: 1;
        color: @gray-2;
        font-weight: bold;
      }
      .clearAll{
        color: @blue-1;
        text-align: right;
        cursor: pointer;
      }
    }
    ul {
      overflow-y: overlay;
      display: flex;
      flex-wrap: wrap;
      li {
        display: flex;
        width: 100%;
        color: #505873;
        align-items: center;
        justify-content: space-between;
        background: @gray-7;
        border-radius: 6px;
        margin-bottom: 12px;
        margin-right: 12px;
        position: relative;
        .li-content{
          height: 100%;
          padding-right: 4px;
          flex: 1;
          .selected-student {
            display: flex;
            justify-content: space-between;
            margin: 8px 0 2px 12px;
            font-size: 14px;
            color: @gray-2;
            height: 22px;
            width: 220px;
            display: inline-flex;
            .selected-name {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding-right: 8px;
            }
          }
          .phone {
            margin: 0 0 8px 12px;
          }
        }

        .delete{
          position: absolute;
          right: 0;
          font-size: 14px;
          margin-right: 11px;
          color: @gray-4;
          cursor: pointer;
          display: none;
        }
        &:hover{
          .delete{
            display: initial;
          }
        }
      }
    }
  }
}
.footer-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tip-wrap {
  display: flex;
  align-items: center;
  color: #FF8800;
}
.text-ellipsis {
  width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>